
export const images = [
  {
    id: 1,
    src: require("../../assets/images/pic1.jpg"),
    title: "대전 유성 부성 테이블 냉장고 컨트롤러/ 팬모터 교체 수리",
    tags: ["#대전", "#우성", "#냉장고", "#수리"],
    blogUrl: "https://blog.naver.com/hongiu/"
  },
  {
    id: 2,
    src: require("../../assets/images/pic2.jpg"),
    title: "대전 우성 그랜드 GRAND 반찬/토핑 냉장고 냉장실 온도 안떨어짐",
    tags: ["#대전", "#우성", "#냉장고", "#수리"],
    blogUrl: "https://blog.naver.com/hongiu/"
  },
  {
    id: 3,
    src: require("../../assets/images/pic3.jpg"),
    title: "대전 스키피오 SKIPIO 냉장고 수리",
    tags: ["#냉장고", "#대전", "#스키피오"],
    blogUrl: "https://blog.naver.com/hongiu/"
  },
  {
    id: 4,
    src: require("../../assets/images/pic4.jpg"),
    title: "대전 스타리온 업소용 냉장고 팬모터 교체 수리",
    tags: ["#냉장고", "#스타리온", "#대전"],
    blogUrl: "https://blog.naver.com/hongiu/"
  },
  {
    id: 5,
    src: require("../../assets/images/pic5.jpg"),
    title: "옥천 우성 반찬냉장고 온도조절기 수리",
    tags: ["#냉장고", "#옥천", "#우성"],
    blogUrl: "https://blog.naver.com/hongiu/"
  },
    {
    id: 6,
    src: require("../../assets/images/pic6.jpg"),
    title: "대전 대덕구 업소용반찬냉장고 수리",
    tags: ["#냉장고", "#수리", "#대전"],
    blogUrl: "https://blog.naver.com/hongiu/"
  },
    {
    id: 7,
    src: require("../../assets/images/pic7.jpg"),
    title: "대전 업소용 냉장고 45박스 선반쫄대수리",
    tags: ["#대전", "#냉장고", "#수리"],
    blogUrl: "https://blog.naver.com/hongiu/"
  },
    {
    id: 8,
    src: require("../../assets/images/pic8.jpg"),
    title: "대전 냉장고 에바 결빙 수리",
    tags: ["#대전", "#수리", "#냉장고"],
    blogUrl: "https://blog.naver.com/hongiu/"
  },
    {
    id: 9,
    src: require("../../assets/images/pic9.jpg"),
    title: "대전 브레마제빙기 스위치 수리",
    tags: ["#제빙기", "#수리", "#대전"],
    blogUrl: "https://blog.naver.com/hongiu/"
  },
    {
    id: 10,
    src: require("../../assets/images/pic10.jpg"),
    title: "대전 아이스트로 제빙기 세척",
    tags: ["#제빙기", "#청소", "#대전","#아이스트로"],
    blogUrl: "https://blog.naver.com/hongiu/"
  },
    {
    id: 11,
    src: require("../../assets/images/pic11.jpg"),
    title: "대전 NORTHPOLE 노스폴 KNP-55 제빙기 수리",
    tags: ["#제빙기", "#수리", "#대전", "#노스폴"],
    blogUrl: "https://blog.naver.com/hongiu/"
  },
    {
    id: 12,
    src: require("../../assets/images/pic12.jpg"),
    title: "대전 카이저제빙기 IMK-450 얼음안만들어짐",
    tags: ["#제빙기", "#수리", "#대전", "#카이저"],
    blogUrl: "https://blog.naver.com/hongiu/"
  },
    {
    id: 13,
    src: require("../../assets/images/pic13.jpg"),
    title: "대전 네오트 제빙기 세척",
    tags: ["#제빙기", "#청소", "#대전", "#네오트"],
    blogUrl: "https://blog.naver.com/hongiu/"
  },
    {
    id: 14,
    src: require("../../assets/images/pic14.jpg"),
    title: "대전 카이저 IMK-3230 제빙기수리-물분사안됨",
    tags: ["#제빙기", "#수리", "#대전", "#카이저"],
    blogUrl: "https://blog.naver.com/hongiu/"
  },
    {
    id: 15,
    src: require("../../assets/images/pic15.jpg"),
    title: "대전계룡세종옥천 CUBIX 제빙기 워터펌프수리",
    tags: ["#제빙기", "#수리", "#대전", "#CUBIX"],
    blogUrl: "https://blog.naver.com/hongiu/"
  },
    {
    id: 16,
    src: require("../../assets/images/pic16.jpg"),
    title: "대전 유성구 매니토웍(ID0606W-261K)세척",
    tags: ["#제빙기", "#청소", "#대전", "#매니토웍",],
    blogUrl: "https://blog.naver.com/hongiu/"
  },
    {
    id: 17,
    src: require("../../assets/images/pic17.jpg"),
    title: "공주 프리오(FRIO)쇼케이스 냉매누설수리",
    tags: [ "#수리", "#공주", "#프리오","#쇼케이스"],
    blogUrl: "https://blog.naver.com/hongiu/"
  },
    {
    id: 18,
    src: require("../../assets/images/pic18.jpg"),
    title: "대전 진우전자 음료냉장고 쇼케이스 수리",
    tags: ["#수리", "#대전", "#진우전자","#쇼케이스"],
    blogUrl: "https://blog.naver.com/hongiu/"
  },
    {
    id: 19,
    src: require("../../assets/images/pic19.jpg"),
    title: "대전 아르네 Arneg  냉동 평대 쇼케이스 HA 에러 수리",
    tags: ["#수리", "#대전", "#아르네","#쇼케이스"],
    blogUrl: "https://blog.naver.com/hongiu/"
  },
    {
    id: 20,
    src: require("../../assets/images/pic20.jpg"),
    title: "대전 서구 쇼케이스 누전 수리",
    tags: ["#수리", "#대전", "#쇼케이스"],
    blogUrl: "https://blog.naver.com/hongiu/"
  },
    {
    id: 21,
    src: require("../../assets/images/pic21.jpg"),
    title: "대전 아이스탑 ICE TOP 음료 쇼케이스 냉장고수리",
    tags: ["#수리", "#대전", "#아이스탑", "#쇼케이스"],
    blogUrl: "https://blog.naver.com/hongiu/"
  },
    {
    id: 22,
    src: require("../../assets/images/pic22.jpg"),
    title: "대전 크리콤(CRECOM)쇼케이스 수리",
    tags: ["#수리", "#대전", "#크리콤", "#쇼케이스"],
    blogUrl: "https://blog.naver.com/hongiu/"
  },
    {
    id: 23,
    src: require("../../assets/images/pic23.jpg"),
    title: "대전 음료수냉장고/음료쇼케이스 콤프레샤 수리",
    tags: ["#수리", "#대전", "#콤프레샤", "#쇼케이스"],
    blogUrl: "https://blog.naver.com/hongiu/"
  },

  {
    id: 24,
    src: require("../../assets/images/pic24.jpg"),
    title: "세종 아르네 ArneG 쇼케이스수리",
    tags: ["#쇼케이스", "#수리", "#세종"],
    blogUrl: "https://blog.naver.com/hongiu/24"
  }
];


export const imagePages = [
  images.slice(0, 8),
  images.slice(8, 16),
  images.slice(16, 24)
];